import { render, staticRenderFns } from "./ExtensionSidebar.vue?vue&type=template&id=db4ee2b0&scoped=true"
import script from "./ExtensionSidebar.vue?vue&type=script&lang=js"
export * from "./ExtensionSidebar.vue?vue&type=script&lang=js"
import style0 from "./ExtensionSidebar.vue?vue&type=style&index=0&id=db4ee2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4ee2b0",
  null
  
)

export default component.exports